import React, { useRef } from "react";
import AppLoadingOverlay from "./AppLoadingOverlay";

export default function AppWorkspace({
  className = "",
  title,
  subtitle,
  actions = null,
  loading = false,
  contentClassName = "",
  children,
}) {
  const hasRenderedContentRef = useRef(!loading);
  if (!loading) {
    hasRenderedContentRef.current = true;
  }
  const showInitialLoading = loading && !hasRenderedContentRef.current;
  const classes = [
    "ds-app-workspace",
    showInitialLoading ? "ds-app-workspace--initial-loading" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  const contentClasses = ["ds-app-workspace__content", contentClassName].filter(Boolean).join(" ");
  const visibleActions = showInitialLoading ? null : actions;
  const hasHeader = Boolean(title || subtitle || visibleActions);

  return (
    <section className={classes}>
      {hasHeader ? (
        <header className="ds-app-workspace__header">
          <div className="ds-app-workspace__header-main">
            {title ? <h1 className="ds-app-workspace__title">{title}</h1> : null}
            {subtitle ? <p className="ds-app-workspace__subtitle">{subtitle}</p> : null}
          </div>
          <div className="ds-app-workspace__actions">{visibleActions}</div>
        </header>
      ) : null}

      <div className={contentClasses}>
        {showInitialLoading ? <AppLoadingOverlay open scope="contained" /> : children}
      </div>
    </section>
  );
}
